module.exports = __webpack_public_path__ + "static/media/manojit.d9fadee8.jpeg";